/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type { ChatInputEntityState, ChatInputEntitySlots } from './ChatInputEntity.types';

/**
 * Render the final JSX of ChatInputEntity
 */
export const renderChatInputEntity_unstable = (state: ChatInputEntityState): JSXElement => {
  assertSlots<ChatInputEntitySlots>(state);

  return (
    <state.root>
      {state.text && <state.text />}
      {state.sensitivity && <state.sensitivity />}
    </state.root>
  );
};
